var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCircleInfoFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M50.667 100.667c27.614 0 50-22.386 50-50s-22.386-50-50-50-50 22.385-50 50 22.385 50 50 50m0-56a6 6 0 0 1 6 6v20a6 6 0 0 1-12 0v-20a6 6 0 0 1 6-6m-6-14a6 6 0 0 1 6-6h.05a6 6 0 1 1 0 12h-.05a6 6 0 0 1-6-6"
})));
export default SvgIconCircleInfoFilled;